import * as React from 'react'
import UIMessages from '../../../utils/ui-messages'
import { Button } from '@mobiscroll/react-latest'
import history from 'src/history'

interface IProps {
  cancelPath: string
  isSaving: boolean
  saveDisabled?: boolean
  onSave?: () => void
}

const EditRiderBottomBar = ({ cancelPath, isSaving, onSave, saveDisabled = false }: IProps) => {
  const saveButtonText = isSaving ? UIMessages.common.saving : UIMessages.common.save
  const handleRedirect = (path: string) => {
    history.push(path)
  }

  return (
    <div className='flex absolute bottom-0 flex items-center justify-end bg-light-grey7 px2 py1 w100 z1'>
      <div className='mr3'>
        <Button
          ariaLabel={`Cancel and redirect to ${cancelPath}`}
          className='mbsc-flat-white-btn'
          onClick={() => handleRedirect(cancelPath)}
        >
          {UIMessages.common.cancel}
        </Button>
        {!onSave && (
          <Button ariaLabel='Submit changes' className='mbsc-success-btn' type='submit'>
            {saveButtonText}
          </Button>
        )}
        {onSave && !saveDisabled && (
          <Button ariaLabel='Save changes' className='mbsc-success-btn' onClick={onSave}>
            {saveButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}

export default EditRiderBottomBar



// WEBPACK FOOTER //
// ./src/components/riders/editrider/EditRiderBottomBar.tsx